import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useViewTracking } from '~/utils/use-view-tracking';
import { ModuleType } from '~/utils/module-type';
import { useNumFormatter } from '~/utils/format';
import { DivisibleStack } from '~/components/divisible-stack';
import { ECommentPermission } from 'shared/models';
import { useScopedAtomValue } from '@lemon8/web-app-shared/ssr';
import { PostDetailModalAtoms } from '../../atoms';
import { CommentNoPermission } from '~/components/comment-no-permission';
import { CommentItem } from './comment-item';
import { CommentsSeeMore } from './comments-see-more';
import { $CurrentPositionPrefix } from '~/models/current-position-prefix';

import './style.scss';

export const ArticleComments: FC = () => {
  const { t } = useTranslation();
  const formatNum = useNumFormatter();
  const article = useScopedAtomValue(PostDetailModalAtoms.$CurrentArticle);
  const { items } = useScopedAtomValue(PostDetailModalAtoms.$CurrentArticleComments);
  const prefix = useScopedAtomValue($CurrentPositionPrefix);

  const ref = useViewTracking({
    onView: () => {
      window.Tea('wap_module_show', {
        current_page_module: prefix + ModuleType.comment,
      });
    },
  });

  const { commentCount, commentPermission } = article;

  if (!commentCount) {
    return null;
  }

  if (commentPermission === ECommentPermission.Disable) {
    return (
      <section id="article-comment-no-permission">
        <CommentNoPermission />
      </section>
    );
  }

  return (
    <div id="article-comment">
      <h2 className="comment-title" ref={ref}>
        {t('comment_count_plural', { num: commentCount }).replace('%d', formatNum(commentCount))}
      </h2>
      <DivisibleStack>
        {items.map((comment) => (
          <CommentItem key={comment.commentId} comment={comment} />
        ))}
      </DivisibleStack>
      <CommentsSeeMore />
    </div>
  );
};
